import { common } from 'ui-lib/color-pallete';
import { alpha } from '@mui/material/styles';
import { CHART_THEME_MODE } from '../const';
import { ChartTheme } from './types';
import { createChartColorGroupPaletteFactory } from './utils';

const DARK_FILL_SEMI_OPACITY = 0.15;
const DARK_TONAL_BACKGROUND_OPACITY = 0.1;

const createDarkChartColorGroupPalette = createChartColorGroupPaletteFactory(DARK_FILL_SEMI_OPACITY, DARK_TONAL_BACKGROUND_OPACITY);

export const darkChartTheme: ChartTheme = {
  mode: CHART_THEME_MODE.DARK,
  palette: {
    general: {
      axis: '#5E617D',
      grid: '#323443',
      labels: alpha('#999BB2', 0.65),
      gridHover: '#21222B',
      fillHover: alpha(common.white, 0.2),
      fillBackground: '#323443',
      scrollBar: common.black,
    },
    primary: createDarkChartColorGroupPalette({
      fillDark2: '#2B2D73',
      fillDark1: '#373A95',
      fill: '#464AB9',
      fillLight1: '#686BDF',
      fillLight2: '#9396EB',
    }),
    secondary: createDarkChartColorGroupPalette({
      fillDark2: '#1B1C22',
      fillDark1: '#343541',
      fill: '#454654',
      fillLight1: '#646578',
      fillLight2: '#838495',
    }),
    red: createDarkChartColorGroupPalette({
      fillDark2: '#5C2425',
      fillDark1: '#8B2D30',
      fill: '#AE474A',
      fillLight1: '#E2797D',
      fillLight2: '#F1B6B8',
    }),
    yellow: createDarkChartColorGroupPalette({
      fillDark2: '#4F440C',
      fillDark1: '#7C6A13',
      fill: '#A5912C',
      fillLight1: '#D0B943',
      fillLight2: '#F5EBB8',
    }),
    green: createDarkChartColorGroupPalette({
      fillDark2: '#28481E',
      fillDark1: '#306520',
      fill: '#4B8B37',
      fillLight1: '#6ABD51',
      fillLight2: '#ADE19D',
    }),
    blue: createDarkChartColorGroupPalette({
      fillDark2: '#0D3C54',
      fillDark1: '#135677',
      fill: '#136B96',
      fillLight1: '#5192B3',
      fillLight2: '#94BDD1',
    }),
    purple: createDarkChartColorGroupPalette({
      fillDark2: '#481971',
      fillDark1: '#6114A3',
      fill: '#7D2CC3',
      fillLight1: '#905BBE',
      fillLight2: '#AB86CB',
    }),
    orange: createDarkChartColorGroupPalette({
      fillDark2: '#542C0D',
      fillDark1: '#773E13',
      fill: '#964B13',
      fillLight1: '#B37C51',
      fillLight2: '#D1AE94',
    }),
    brand: createDarkChartColorGroupPalette({
      fillDark2: '#0C5030',
      fillDark1: '#0C693E',
      fill: '#118850',
      fillLight1: '#51B385',
      fillLight2: '#94D1B5',
    }),
  },
};

